import Vue from 'vue';

// パーミッションによるメソッド
import { handleByPermission } from '@/permissions';
Vue.prototype.$can = target => {
  return handleByPermission(target);
};

// User meta / Vendorによるハンドリング
import display from '@/prototypes/display';
Vue.prototype.$display = target => {
  return display(target);
};

// Sanitizer
import sanitizer from 'sanitize-html';
Vue.prototype.$sanitizer = sanitizer;

/**
 * Global Flags
 */
import flag from '@/prototypes/flag';
Vue.prototype.$flag = id => {
  return flag(id);
};

/**
 * Alphaus Plugins
 */
import notify from '@/prototypes/notify';
import loading from '@/prototypes/loading';
import logger from '@/prototypes/logger';

Vue.prototype.$alpha = {
  notify: notify,
  loading: loading,
  logger: logger,
};
